import { Inject, Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { ICarFullResponse } from '../model/http/cars.model';
import { ILandingPage } from '../model/http/landing.model';
import { WINDOW } from '../utils/window';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private isLoading = new BehaviorSubject(false);
  private generalNotificationMessage = new Subject<string>();
  private carsResult = new Subject<ICarFullResponse>();
  private searchCarsUrl = new Subject<string>();
  private encryptCarsUrl = new Subject<string>();
  private toggleNavPanel = new Subject<boolean>();
  private orderSelection = new Subject<number>();
  private sideLandingMenu = new Subject<ILandingPage[]>();
  private pricesResults = new Subject<any>();

  private searchFullPrice = new Subject<string>();
  private searchFullRentPrice = new Subject<string>();

  private catalogImagesSearcher = new Subject<string>();
  private totalCarsResults = new Subject<number>();
  private quoterCarData = new Subject<any>();
  private quoterCreditCarData = new Subject<string>();
  private deadlineSelect = new Subject<any>();
  private allDeadlineSelect = new Subject<any>();
  idKeycloak: string = '';
  isLoged: boolean = false;
  private quoterCarId = new Subject<string>();
  private updatePreauthorize = new Subject<boolean>();
  private interactionUserPanel = new Subject<boolean>();

  private isBlocked = new BehaviorSubject<boolean>(false);

  private isBlockedForContracts = new BehaviorSubject<boolean>(false);
  
  private screenSize = new BehaviorSubject<number>(this.window.innerWidth);

  private showShareLink = new Subject<boolean>();
  private getTopCars = new Subject<boolean>();
  private isTopCars = new Subject<boolean>();
  private filtersTypeCar = new Subject<any>();
  private selectTypeCar = new Subject<any>();
  private chipsFilter = new Subject<any>();
  private clearFilter = new Subject<any>();
  private isPriceFilter = new Subject<Object>();
  private isRentPriceFilter = new Subject<Object>();
  private subject = new Subject<any>();
  private subjectDownloadPdf = new Subject<any>();
  private km:number = 0;
  private period?:number;
  private creditPeriod?:number;
  private selectedMaintenanceExpenses:boolean = false;
  private tenPercentPrice: number = 0;
  private persontype:string = "";
  private balloonMax = new Subject<void>();

  constructor(@Inject(WINDOW) private window: Window) {}

  setIsLoading(loading: boolean): void {
    this.isLoading.next(loading);
  }

  getIsLoading(): Observable<boolean> {
    return this.isLoading.asObservable();
  }

  getGeneralNotificationMessage(): Observable<string> {
    return this.generalNotificationMessage.asObservable();
  }

  setGeneralNotificationMessage(msg: string): void {
    this.generalNotificationMessage.next(msg);
  }

  getToken(): string {
    return sessionStorage.getItem('token') || '';
  }

  setToken(token: string): void {
    sessionStorage.setItem('token', token);
  }

  getTokenService(): string {
    return sessionStorage.getItem('token_service') || '';
  }

  setTokenService(token: string): void {
    sessionStorage.setItem('token_service', token);
  }

  removeToken(): void {
    sessionStorage.removeItem('token');
  }

  userIsAuthenticated(): boolean {
    return Boolean(sessionStorage.getItem('token'));
  }

  checkParamStringBrand(param: any): string {
    return '?brands[]=' + param.toString();
  }

  checkParamStringSubBrand(param: string): string {
    return '?subbrand[]=' + param.toString();
  }

  checkParamStringFastSearch(param: string): string {
    return '?search[]=' + param.toString();
  }

  addParamStringBrand(param: any, index: number, urlParam: string): string {
    return (index === 0 ? `?${urlParam}=` : `&${urlParam}=`) + param.toString();
  }

  setSearchUrl(url: any): void {
    this.searchCarsUrl.next('page=1&size=24&order=1' + url);
  }

  getSearchUrl(): Observable<any> {
    return this.searchCarsUrl.asObservable();
  }

  setPrices(arrPrice: any): void {
    this.pricesResults.next(arrPrice);
  }

  getPrices(): Observable<any> {
    return this.pricesResults.asObservable();
  }

  setHideNavMenu(val: boolean): void {
    this.toggleNavPanel.next(val);
  }

  getHideNavMenu(): Observable<boolean> {
    return this.toggleNavPanel.asObservable();
  }

  setOrderSelection(val: number): void {
    this.orderSelection.next(val);
  }

  getOrderSelection(): Observable<number> {
    return this.orderSelection.asObservable();
  }

  setSideLandingMenu(menu: ILandingPage[]): void {
    this.sideLandingMenu.next(menu);
  }

  getSideLandingMenu(): Observable<ILandingPage[]> {
    return this.sideLandingMenu.asObservable();
  }

  setCatalogImagesSearcher(value: any): void {
    this.catalogImagesSearcher.next(value);
  }

  getCatalogImagesSearcher(): Observable<any> {
    return this.catalogImagesSearcher.asObservable();
  }

  getTotalCarsResults(): Observable<number> {
    return this.totalCarsResults.asObservable();
  }

  setTotalCarsResults(results: number): void {
    this.totalCarsResults.next(results);
  }

  setQuoterData(data: any): void {
    this.quoterCarData.next(data);
  }

  getQuoterData(): Observable<any> {
    return this.quoterCarData;
  }

  setDeadlineSelect(deadline: any): void {
    if(deadline) {
      this.setPeriod(deadline.period);
      this.setSelectedMaintenanceExpenses(deadline.deliveryCost.hasOwnProperty("maintenanceExpenses"));
    }
    this.deadlineSelect.next(deadline);
  }

  getDeadlineSelect(): Observable<any> {
    return this.deadlineSelect.asObservable();
  }

  setDeadlineCreditSelect(deadline: any): void {
    if(deadline) {
      this.setPeriod(deadline.period);
    }
    this.deadlineSelect.next(deadline);
  }

  getIdKeycloak = () => this.idKeycloak;

  setIdKeycloak = (id: any) => (this.idKeycloak = id);

  getPersontype = () => this.persontype;

  setPersontype = (regimen: string) => (this.persontype = regimen);

  setCarIdQuoter(id: any): void {
    this.quoterCarId.next(id);
  }

  getCarIdQuoter(): Observable<any> {
    return this.quoterCarId.asObservable();
  }

  setUpdatePreauthorize(value: boolean): void {
    this.updatePreauthorize.next(value);
  }

  getUpdatePreauthorize(): Observable<boolean> {
    return this.updatePreauthorize.asObservable();
  }

  setInteractionUserPanel(value: boolean): void {
    this.interactionUserPanel.next(value);
  }

  getInteractionUserPanel(): Observable<boolean> {
    return this.interactionUserPanel.asObservable();
  }

  setIsBlocked(value: boolean) {
    this.isBlocked.next(value);
  }

  getIsBlocked(): Observable<boolean> {
    return this.isBlocked.asObservable();
  }

  // para bloquear pantalla cuando se generen contratos

  setIsBlockedForContracts(value: boolean) {
    this.isBlockedForContracts.next(value);
  }

  getIsBlockedForContracts(): Observable<boolean> {
    return this.isBlockedForContracts.asObservable();
  }

  setScreenSize(value: number) {
    this.screenSize.next(value);
  }

  getScreenSize(): Observable<number> {
    return this.screenSize.asObservable();
  }

  getIsLoged = () => this.isLoged;

  setIsLoged = (value: boolean) => (this.isLoged = value);

  setShowShareLink(value: boolean) {
    this.showShareLink.next(value);
  }

  getShowShareLink(): Observable<boolean> {
    return this.showShareLink.asObservable();
  }

  setClickTopCars(value: boolean) {
    this.getTopCars.next(value);
  }

  getClickTopCars(): Observable<boolean> {
    return this.getTopCars.asObservable();
  }

  setIsTopCars(value: boolean) {
    this.isTopCars.next(value);
  }

  getIsTopCars(): Observable<boolean> {
    return this.isTopCars.asObservable();
  }

  setFiltersTypeCar(value: any) {
    this.filtersTypeCar.next(value);
  }

  getFiltersTypeCar(): Observable<any> {
    return this.filtersTypeCar.asObservable();
  }

  setSelectTypeCar(value: any) {
    this.selectTypeCar.next(value);
  }

  getSelectTypeCar(): Observable<any> {
    return this.selectTypeCar.asObservable();
  }

  setChipsFilter(value: any) {
    this.chipsFilter.next(value);
  }

  getChipsFilter(): Observable<any> {
    return this.chipsFilter.asObservable();
  }

  setClearFilter(chip: any) {
    this.clearFilter.next(chip);
  }

  getClearFilter(): Observable<any> {
    return this.clearFilter.asObservable();
  }

  setPriceFilter(value: any) {
    this.isPriceFilter.next(value);
  }

  getPriceFilter(): Observable<any> {
    return this.isPriceFilter.asObservable();
  }

  setRentPriceFilter(value: any) {
    this.isRentPriceFilter.next(value);
  }

  getRentPriceFilter(): Observable<any> {
    return this.isRentPriceFilter.asObservable();
  }


   /**
   * Function to shared excecute function of children to parent
   * @author victor.mendez
   */
   sendSharedFunction(data:any) {
    this.subject.next(data);
  }

  /**
   * Get observable to execute functions of children to parent
   * to Open Modal
   * @return {Observable}
   * @author victor.mendez
   */
  getSharedFunction() {
    return this.subject.asObservable();
  }

   /**
   * Function to shared excecute function of children to parent
   * @author victor.mendez
   */
   sendDownloadPdfCredit(data:any) {
    this.subjectDownloadPdf.next(data);
  }

  /**
   * Get observable to execute functions of children to parent
   * to Open Modal
   * @return {Observable}
   * @author victor.mendez
   */
  getDownloadPdfCredit() {
    return this.subjectDownloadPdf.asObservable();
  }

  setKm(km: number) {
    this.km = km;
  }

  getKm() {
    return this.km;
  }

  setPeriod(period:number) {
    this.period = period;
  }

  getPeriod() {
    return this.period;
  }

  setSelectedMaintenanceExpenses(selected: boolean) {
    this.selectedMaintenanceExpenses = selected;
  }

  getSelectedMaintenanceExpenses() {
    return this.selectedMaintenanceExpenses;
  }

  setTenPercentPrice(tenPercentPrice:number) {
    this.tenPercentPrice = tenPercentPrice;
  }

  getTenPercentPrice() {
    return this.tenPercentPrice;
  }

  setAllDeadlines(deadline:any): void {
    this.allDeadlineSelect.next(deadline);
  }

  getAllDeadlines(): Observable<any> {
    return this.allDeadlineSelect.asObservable();
  }

  getBalloonMax() {
    return this.balloonMax.asObservable();
  }

  setBalloonMax(plazo: any) {
    return this.balloonMax.next(plazo);
  }

}
